export default __webpack_public_path__ + "static/media/facebook.9653764b.svg";